import { buildHttpHeaders } from "../utils/buildHttpHeaders";
import { CompanyEmailTemplateDto } from "../common/Interfaces";

const BASE_URL = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}/api/emailTemplates`;

export async function getDefaultEmailTemplates(accessToken: string, backendHeader: string, signal?: AbortSignal): Promise<CompanyEmailTemplateDto[]> {
  const headers = buildHttpHeaders(accessToken, backendHeader);
  const res = await fetch(`${BASE_URL}/default`, { method: 'GET', headers, signal });

  if (!res.ok) throw new Error(await res.text());
  return (await res.json()) as CompanyEmailTemplateDto[];
}

export async function getCompanyEmailTemplates(accessToken: string, backendHeader: string, signal?: AbortSignal): Promise<CompanyEmailTemplateDto[]> {
  try {
    const headers = buildHttpHeaders(accessToken, backendHeader);
    const response = await fetch(`${BASE_URL}/company-email-templates`, { method: "GET", headers, signal });

    if (response.ok) {
      const templates: CompanyEmailTemplateDto[] = await response.json();
      return templates;
    } else {
      const text = await response.text();
      throw new Error(`Failed to get company email templates: ${text}`);
    }
  } catch (error) {
    console.error("getCompanyEmailTemplates error:", error);
    throw error;
  }
}

export async function postCompanyEmailTemplate(dto: CompanyEmailTemplateDto, accessToken: string, backendHeader: string): Promise<CompanyEmailTemplateDto> {
  const headers = buildHttpHeaders(accessToken, backendHeader);
  const response = await fetch(`${BASE_URL}/company`, { method: "POST", headers, body: JSON.stringify(dto) });

  if (!(response.status === 200 || response.status === 201)) {
    throw new Error(`POST /company failed: ${await response.text()}`);
  }

  return (await response.json()) as CompanyEmailTemplateDto;
}

export async function postCompanyAssignmentEmailTemplate(dto: CompanyEmailTemplateDto, accessToken: string, backendHeader: string): Promise<CompanyEmailTemplateDto> {
  const headers = buildHttpHeaders(accessToken, backendHeader);
  const response = await fetch(`${BASE_URL}/company/${encodeURIComponent(backendHeader)}`, {
    method: "POST",
    headers,
    body: JSON.stringify(dto),
  });

  if (!(response.status === 200 || response.status === 201)) {
    throw new Error(`POST /company/${backendHeader} failed: ${await response.text()}`);
  }

  return (await response.json()) as CompanyEmailTemplateDto;
}

export async function updateCompanyEmailTemplateAsync(idmEmailTemplate: CompanyEmailTemplateDto, accessToken: string, backendHeader: string): Promise<void> {
  const headers = buildHttpHeaders(accessToken, backendHeader);
  const response = await fetch(`${BASE_URL}/company/`, { method: "PATCH", headers, body: JSON.stringify(idmEmailTemplate) });

  if (!response.ok) {
    const body = await response.text();
    throw new Error(`PATCH email-template failed: ${body}`);
  }
}

export async function updateCompanyAssignmentEmailTemplateAsync(updateDto: CompanyEmailTemplateDto, accessToken: string, backendHeader: string) {
  const res = await fetch(`${BASE_URL}/company/assignmentTemplate`, { method: "PATCH", headers: buildHttpHeaders(accessToken, backendHeader), body: JSON.stringify(updateDto), });

  if (!res.ok) {
    throw new Error(`PATCH /company/assignmentTemplate failed: ${await res.text()}`);
  }
}  